import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  theme?: 'black' | 'onyx' | 'graphite';
  id?: string;
}
export function Section({
  children,
  className = '',
  theme = 'black',
  id
}: SectionProps) {
  const themeClasses = {
    black: 'bg-black text-bone',
    onyx: 'bg-onyx text-bone',
    graphite: 'bg-graphite text-bone'
  };
  return <section id={id} className={`py-20 md:py-32 overflow-hidden ${themeClasses[theme]} ${className}`} data-id="element-239">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.7,
      ease: [0.21, 0.47, 0.32, 0.98]
    }} className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-240">
        {children}
      </motion.div>
    </section>;
}